import React, { useContext, useCallback, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiEventType, BiDataHook } from '@wix/da-bi/pkg/constants';
import CommentBox from '../../../CommentBox';
import { dateDiff } from '../../../Timestamp/functions';
import { generateReplyEditorId } from '../../utils';
import { useVerification } from '../../../VerificationPopup/withVerification';
import LoadableCommentReduxModule from '../../LoadableCommentReduxModule';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import { CommentContext } from '../CommentContext';
import LikeButton from '../LikeButton';
import AwardBadgeButton from '../AwardBadgeButton';
import CommentIcon from '../../../Icons/Comment';
import { IconSize } from '../../../Icons/IconWrap';
import CommentBadges from '../CommentBadges';
import ReplyButton from './ReplyButton';
import s from './CommentFooter.scss';
var CommentFooter = function (_a) {
    var _b = _a.canPostComment, canPostComment = _b === void 0 ? true : _b, isLoggedIn = _a.isLoggedIn, disableEdit = _a.disableEdit, showReplyForm = _a.showReplyForm, onReplyPosted = _a.onReplyPosted, onCloseReply = _a.onCloseReply, replyClassName = _a.replyClassName, className = _a.className, likeButtonClassName = _a.likeButtonClassName, isCommentReduxReady = _a.isCommentReduxReady, currentUser = _a.currentUser;
    var _c = useState(false), isReplyCanceled = _c[0], setIsReplyCanceled = _c[1];
    var _d = useContext(CommentContext), comment = _d.comment, isReplying = _d.isReplying, setEditingState = _d.setEditingState, isCommentVisible = _d.isCommentVisible;
    var commentId = comment.commentId;
    var restrictToVerified = useVerification().restrictToVerified;
    var t = useTranslation().t;
    var onClickEdit = restrictToVerified('comment', function () {
        return setEditingState('editing');
    });
    var onCloseEditor = useCallback(function () {
        onCloseReply(commentId);
        setIsReplyCanceled(true);
        setEditingState('none');
    }, [commentId, onCloseReply, setEditingState]);
    var onReplyDone = useCallback(function (result) {
        setEditingState('none');
        onReplyPosted && result.comment && onReplyPosted(result);
    }, [onReplyPosted, setEditingState]);
    var canReply = !comment.isHidden && !comment.isSpam;
    // Limited to 1 day since post
    var canEdit = !disableEdit &&
        comment.isAuthor &&
        dateDiff(new Date().toISOString(), comment.posted, 'days') === 0;
    if (!isCommentVisible) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(LoadableCommentReduxModule, null),
        React.createElement("div", { className: classnames(s['footer'], className), "data-hook": BiDataHook.COMMENT_FOOTER },
            (canPostComment || !isLoggedIn) && (React.createElement(React.Fragment, null,
                canEdit && (React.createElement(PlainButtonOrLink, { className: classnames(s['footer-item'], s['action'], s['action-with-text']), onClick: onClickEdit, "data-hook": BiDataHook.COMMENT_EDIT_BUTTON, biData: {
                        evid: BiEventType.COMMENT_EDIT_CLICK,
                        commentid: comment.commentId,
                        typeid: comment.typeId,
                        itemid: comment.itemId,
                    }, disabled: !isCommentReduxReady }, t('comment.action.edit'))),
                React.createElement(ReplyButton, { commentId: commentId, className: classnames(s['footer-item'], s['action'], s['action-with-text']), disabled: !isCommentReduxReady, isLoggedIn: isLoggedIn, showReplyForm: showReplyForm, canAutoOpenReplyForm: !isReplyCanceled },
                    React.createElement("span", { className: s['reply-with-icon'] },
                        React.createElement(CommentIcon, { className: classnames(s['reply-icon']), size: IconSize.SMALLER }),
                        t('comment.action.reply'))))),
            React.createElement("div", { className: classnames(s['footer-item'], s['action']) },
                React.createElement(LikeButton, { className: likeButtonClassName, disabled: !isCommentReduxReady })),
            !comment.isAuthor && (React.createElement("div", { className: classnames(s['footer-item'], s['action']) },
                React.createElement(AwardBadgeButton, { className: likeButtonClassName, disabled: !isCommentReduxReady }))),
            React.createElement(CommentBadges, { className: s['badge-list'] })),
        isReplying && canReply && (React.createElement("div", { className: classnames(s['reply-block'], replyClassName) },
            React.createElement(CommentBox, { onPublishSuccess: onReplyDone, id: generateReplyEditorId(comment), className: s['commentbox-reply'], commentableType: comment.typeId, commentableItemId: comment.itemId, user: currentUser, replyComment: comment, autoFocus: true, onClose: onCloseEditor, canPostComment: !!canPostComment })))));
};
CommentFooter.displayName = 'CommentFooter';
export default CommentFooter;
//# sourceMappingURL=CommentFooter.js.map